import React, { useState, useCallback } from "react";
import axios from "../Assets/Lib/axios";
import {
  Button,
  Page,
  Loading,
  Card,
  ButtonGroup,
  TextField,
  FormLayout,
  Layout,
  Toast,
  Spinner,
  InlineError,
} from "@shopify/polaris";

function ChannelTag() {
  const [value, setValue] = useState("");
  const handleChange = useCallback((newValue) => setValue(newValue), []);
  const handleSubmit = () => {
    axios
      .get(`admin/v1/registration-requests-channel-tag`)
      .then((res) => {})
      .catch((err) => console.log(""));
  };
  return (
    <FormLayout>
      <Button onClick={handleSubmit}>Submit</Button>
    </FormLayout>
  );
}

export default ChannelTag;
